import * as yup from 'yup';

export const validations = yup.object().shape({
  selectedService: yup
    .string()
    .required('O serviço é obrigatório')
    .nullable(),
  daysAfterSale: yup
    .string()
    .required('O envio após X dias é obrigatório')
    .nullable()
});